
    // this file was auto generated by python script
    import Navigation2 from './Navigation2';
    export default Navigation2;
    